import {
  CARE_PLAN_SERVICE_KEY,
  CARE_PLAN_SERVICE_NAME,
  CarePlanServiceKey,
  CarePlanServiceName,
} from '@/api';

export const SERVICE_INFO_ORDER: CarePlanServiceKey[] = [
  CARE_PLAN_SERVICE_KEY.IMAGING_BASE_BASIC,
  CARE_PLAN_SERVICE_KEY.IMAGING_BASE_STANDARD,
  CARE_PLAN_SERVICE_KEY.IMAGING_BASE_ADVANCE_NEURO,
  CARE_PLAN_SERVICE_KEY.IMAGING_BASE_BODY_COMPOSITION,
];

// TODO: Remove this once we have the correct display names
export const SERVICE_DISPLAY_NAME: Partial<Record<CarePlanServiceName, string>> = {
  [CARE_PLAN_SERVICE_NAME.IMAGING_BASE_ADVANCE_HEART]: 'Advanced Heart Health Scan',
  [CARE_PLAN_SERVICE_NAME.IMAGING_BASE_ADVANCE_NEURO]: 'Advanced Brain Health Scan',
};
